module.exports = __webpack_public_path__ + "media/img/specialize/item4-edfb2940c702a651dbea6631dca2d32d.svg";